import React, { PureComponent } from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../constants/text';
import { FadeIn } from '../../../../core/util/commonCssAnimations';
import WarningIcon from '../../../SolvPatternLibrary/Icons/WarningWhiteBorder';
import SlotShape from '../../../../shapes/Slot';
import PropTypes from 'prop-types';

const Title = styled.div`
  color: ${colors.peaches};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: -0.27px;
  text-align: center;
  line-height: 18px;
`;

const Text = styled.div`
  color: ${colors.blueMonday};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  letter-spacing: -0.25px;
  line-height: 18px;
  text-align: center;
  margin-top: 4px;
`;

const StyledWarningIcon = styled(WarningIcon)`
  font-size: 18px;
  position: relative;
  bottom: 1px;
  margin-right: 5px;
`;

const TitleContainer = styled.div`
  display: flex;
  width: 130px;
  margin: 0 auto;
`;

const Container = styled.div`
  margin-bottom: 20px;
  animation: ${FadeIn} 300ms linear;
`;

class PeakTimeAlert extends PureComponent {
  render() {
    const { slot } = this.props;
    if (!slot || !slot.isBusy) {
      return null;
    }

    return (
      <Container className={this.props.className}>
        <TitleContainer>
          <StyledWarningIcon />
          <Title>Peak Time Alert</Title>
        </TitleContainer>
        <Text>Visits during busy times may be subject to delays.</Text>
      </Container>
    );
  }
}

PeakTimeAlert.propTypes = {
  slot: SlotShape,
  className: PropTypes.string,
};

export default PeakTimeAlert;
